import { Mediator, app, payload } from "modular-openscriptjs";
import { eParse, inform } from "../helpers";
import { STRINGS, api, uc } from "../declarations";
import { routes } from "../backendRoutes";
import { $e } from "../ojs.events";

export class AiCredit extends Mediator {
    $$aiCredit = {
        needs: {
            deposit: (ed, event) =>
                this.send($e.aiCredit.needs.depositForm, ed),
            purchase: (ed, event) => {
                this.purchase(ed, event);
            },
            payment: (ed, event) => this.getPayment(ed, event),
            balance: (ed, event) => this.getBalance(),
        },

        deposited: (ed, event) => this.getBalance(ed, event),
    };

    $$user = {
        authenticated: (ed, event) => this.send($e.aiCredit.needs.balance),
        loggedOut: (ed, event) => this.setAiCredit(),
    };

    $$product = {
        stored: (ed, event) => {
            setTimeout(() => {
                app("broker").send($e.aiCredit.needs.balance);
            }, 60000);
        },
    };

    $$payment = {
        completed: (ed, event) => {
            this.getBalance(ed, event);

            let data = eParse(ed);
            if (data.meta.get("type") != "ai-credit-purchase") {
                return;
            }

            inform("AI Credit purchase complete", STRINGS.SUCCESS);
        },
    };

    async purchase(ed, event) {
        let data = eParse(ed);
        let res = await api.post(`${routes.aiCreditPurchases}`, {
            credits: data.message.get("credits", 0),
        });

        if (!res) {
            return this.send($e.aiCredit.has.depositError, ed);
        }

        inform(res.message, STRINGS.SUCCESS);
        this.send($e.aiCredit.is.depositing, ed);

        this.send(
            $e.aiCredit.needs.payment,
            payload(
                {
                    purchaseId: res.data.purchase.id,
                    purchase: res.data.purchase,
                    amount: res.data.purchase.amount,
                },
                data.meta,
            ),
        );
    }

    getPayment(ed, event) {
        let data = eParse(ed);

        if (data.message.get("purchaseId", 0) == 0) {
            inform("Invalid purchase", STRINGS.ERROR);
            app("router").to("/");
            return;
        }

        let purchaseId = data.message.get("purchaseId");

        data.meta.put("route", `${routes.aiCreditPurchases}/${purchaseId}/pay`);
        data.meta.put("type", "ai-credit-purchase");
        data.meta.put("typeId", purchaseId);

        if (uc.paymentMethod) {
            uc.paymentMethod.value = "mpesa";
        } else {
            uc.states({
                paymentMethod: "mpesa",
            });
        }

        this.broadcast(
            $e.payment.needs.collection,
            payload(data.message, data.meta),
        );
    }

    async getBalance(ed, event) {
        let res = await api.get(
            `${routes.users}/ai-credits`,
            {},
            { silent: true },
        );

        if (!res) {
            this.setAiCredit();
            return;
        }

        this.setAiCredit(res.data.ai_credit_wallet);
        this.send($e.aiCredit.has.balance);
    }

    setAiCredit(wallet = { balance: 0 }) {
        uc.aiCredit.value = wallet;
    }
}
